import React, {Component} from 'react'
import {inject, observer} from "mobx-react"
import LoginComponent from '../library/LoginComponent'

@inject('UserStore')
@observer
class Login extends Component {
    state = {
        username: '',
        password: '',
        otp: '',
        showOtpModal: false,
        showOtpErrorModal: false,
        invalidOtp: false,
    };

    handleChange = (value, name) => {
        this.setState((state) => ({
            [name]: value
        }))
    };

    login = async (e) => {
        const {UserStore} = this.props
        e.preventDefault()
        let formData = new FormData()
        formData.append('user_type', 'Employee')
        formData.append('twoFactorAuthentication', true)
        formData.append('username', this.state.username)
        formData.append('password', this.state.password)

        const loginResponse = await UserStore.login(formData)

        if (loginResponse && loginResponse.requiresOtp) {
            this.setState({
                showOtpModal: !loginResponse.error,
                showOtpErrorModal: !!loginResponse.error,
                invalidOtp: false,
            })
        }
    };

    handleOtpChange = (value) => {
        this.setState({ otp: value, invalidOtp: false });
    };

    handleOtpSubmit = async (e) => {
        if (e && e.preventDefault) e.preventDefault();
        const { UserStore } = this.props;
        const isValid = await UserStore.verifyOtp(this.state.otp.trim());
        if (!isValid) {
            this.setState({ invalidOtp: true });
        } else {
            this.setState({ showOtpModal: false, otp: '', invalidOtp: false });
        }
    };

    handleOtpCancel = () => {
        this.setState({ showOtpModal: false, otp: '', invalidOtp: false });
    };


    render() {
        const { UserStore } = this.props

        return (
            <LoginComponent
                loading={UserStore.loading}
                title="Factory Production"
                handleChange={this.handleChange}
                username={this.state.username}
                password={this.state.password}
                otp={this.state.otp}
                login={this.login}
                showOtpModal={this.state.showOtpModal}
                showOtpErrorModal={this.state.showOtpErrorModal}
                invalidOtp={this.state.invalidOtp}
                handleOtpSubmit={this.handleOtpSubmit}
                handleOtpChange={this.handleOtpChange}
                handleOtpCancel={this.handleOtpCancel}
            />
        )
    }
}

export default Login
